import { render, staticRenderFns } from "./PayrollHistoricalRates.vue?vue&type=template&id=fec9523c&scoped=true&"
import script from "./PayrollHistoricalRates.vue?vue&type=script&lang=js&"
export * from "./PayrollHistoricalRates.vue?vue&type=script&lang=js&"
import style0 from "./PayrollHistoricalRates.vue?vue&type=style&index=0&id=fec9523c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec9523c",
  null
  
)

export default component.exports